/// <amd-module name="typeahead/core/geolocation/GeolocationSuggestion"/>

import {Suggestion} from "typeahead/core/Suggestion";

export class GeolocationSuggestion extends Suggestion {
    public shouldTriggerDomElementChangeOnSelection(): boolean {
        return false;
    }
}
